// extracted by mini-css-extract-plugin
export default {"inputBox":"Search_inputBox__F8gR4","searchList":"Search_searchList__FX3V6","closeButton":"Search_closeButton__QUtPk"};